<template lang="html">
  <div v-if="competitions" class="competitions-page-wrapper">
    <!-- HEADER -->
    <div class="header">
      <h1>{{$t('competitions.main.title')}}</h1>
      <h3>{{ $t('competitions.main.subTitle') }}</h3>
      <p>
        {{ $t('competitions.main.subTxt') }}
      </p>
    </div>
    <div class="spliter"></div>
    <!-- active competition -->
    <div
      v-if="competitions.active"
      v-for="competition in competitions.active"
      :key="competition.cmp_id"
      class="active-competition-wrapper"
    >
      <router-link
        :to="{ name: 'Competition', params: { id: competition.cmp_id } }"
      >
        <h2 style="margin-top: 0px;">
          {{$t('competitions.main.currentCompetition')}} “{{ competition.cmp_theme }}”
        </h2>
      </router-link>

      <p>{{ competition.cmp_description }}</p>
      <span class="duration"
        >
        {{$t('competitions.main.duration')}}
        {{
          $moment
            .utc(competition.cmp_from_post)
            .local()
            .format('DD.MM.YYYY. HH:mm')
        }}
       -
        {{
          $moment
            .utc(competition.cmp_to_vote)
            .local()
            .format('DD.MM.YYYY. HH:mm')
        }}
        {{$t('competitions.main.hours')}}:
      </span>
      <div class="competition-info">
        <div class="point"></div>
        <p style="margin: 10px 0;">
          {{$t('competitions.main.sendingReceiving')}}
          {{
            $moment
              .utc(competition.cmp_from_post)
              .local()
              .format('DD.MM.YYYY. HH:mm')
          }}
          {{$t('competitions.main.hours')}}  {{$t('competitions.main.to')}}
          {{
            $moment
              .utc(competition.cmp_to_post)
              .local()
              .format('DD.MM.YYYY. HH:mm')
          }}
          {{$t('competitions.main.hours')}}.
        </p>
      </div>
      <div class="competition-info">
        <div class="point"></div>
        <p style="margin: 10px 0;">
          {{$t('competitions.main.voteStart')}}
          {{
            $moment
              .utc(competition.cmp_from_vote)
              .local()
              .format('DD.MM.YYYY. HH:mm')
          }}
          {{$t('competitions.main.hoursTo')}}
          {{
            $moment
              .utc(competition.cmp_to_vote)
              .local()
              .format('DD.MM.YYYY. HH:mm')
          }}
          {{$t('competitions.main.hours')}}.
        </p>
      </div>
      <div class="btn-wrapper">
        <router-link
          v-if="getActiveCompetitionData && isPosting"
          :to="{ name: 'CompetitionEntry', params: { id: competition.cmp_id } }"
        >
          <div class="btn">
            {{ $t('competitions.tr.setWork') }}
          </div>
        </router-link>
        <router-link
          :to="{ name: 'Competition', params: { id: competition.cmp_id } }"
        >
          <div class="btn dark">
            {{$t('competitions.main.learnMore')}}
          </div>
        </router-link>
      </div>
    </div>
    <!-- next competitions -->
    <div
      v-if="competitions.upcoming.length > 0"
      class="next-competitions-wrapper no-wrap"
    >
      <div class="next-competitions">
        <nextCompetition
          v-for="data in competitions.upcoming"
          :key="data.cmp_id"
          :data="data"
        />
      </div>
    </div>
    <!-- next year -->
    <div
      v-if="competitions.next_year.length > 0"
      class="next-competitions-wrapper white"
    >
      <div class="next-competitions">
        <h2 style="margin-top: 0px; margin-bottom: 60px;">
          {{ $t('competitions.main.plannedCompetitions') }}
        </h2>
        <nextYearCompetition
          v-for="data in competitions.next_year"
          :key="data.cmp_id"
          :data="data"
        />
      </div>
    </div>
    <!-- archived competitions -->
    <div v-if="competitions.archived.length > 0" class="archived-competitions">
      <h2 style="margin-bottom: 60px;"> {{ $t('competitions.main.archive') }}</h2>
      <div class="archived-competitions-cards-wrapper">
        <router-link
          v-if="competitions"
          v-for="competition in competitions.archived"
          :key="competition.cmp_id"
          :to="{ name: 'Competition', params: { id: competition.cmp_id } }"
        >
          <div class="competition">
            <div class="name">
              {{ competition.cmp_name }}
            </div>
            <div class="">
              <div class="theme">
                {{ '"' + competition.cmp_theme + '"' }}
              </div>
              <div class="date">
                {{ $moment(competition.cmp_from_post).format('DD.MM.YYYY.') }} -
                {{ $moment(competition.cmp_to_vote).format('DD.MM.YYYY.') }}
              </div>
            </div>
          </div>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { api } from '@/api'
import nextYearCompetition from '../components/competition/nextYearCompetition.vue'
import nextCompetition from '../components/competition/nextCompetition.vue'
export default {
  name: 'Competitions',
  data () {
    return {
      competitions: null,
      activeCompetition: null
    }
  },
  components: {
    nextCompetition,
    nextYearCompetition
  },
  mounted () {
    this.getCompetitions()
    this.getActiveCompetition()
  },
  methods: {
    getCompetitions () {
      api
        .getCompetitions()
        .then(res => {
          // console.log(res.data)
          this.competitions = res.data
        })
        .catch(e => {
          console.log(e)
        })
    },
    async getActiveCompetition () {
      try {
        let params = {
          type: 'active'
        }
        let res = await api.getActiveCompetition(params)
        this.activeCompetition = res.data.data
      } catch (e) {
        console.log(e)
      }
    }
  },
  computed: {
    getActiveCompetitionData () {
      return this.activeCompetition
    },
    isPosting () {
      if (this.activeCompetition) {
        let now = new Date()
        let start = new Date(
          this.$moment.utc(this.activeCompetition.cmp_from_post)
        )
        let end = new Date(this.$moment.utc(this.activeCompetition.cmp_to_post))
        if (now > start && now < end) {
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.competitions-page-wrapper {
  text-align: left;
  width: 100%;

  a {
    text-decoration: none;
    color: $text-color;
  }

  h1 {
    font-weight: 500;
    font-size: 38px;
    line-height: 52px;
    letter-spacing: 0.06em;
    text-transform: uppercase;
  }
  h2 {
    font-weight: 500;
    font-size: 30px;
    line-height: 41px;
    letter-spacing: 0.06em;
    text-transform: uppercase;
  }
  h3 {
    font-weight: 500;
    font-size: 24px;
    color: rgba(100, 100, 100, 0.96);
  }
  p {
    font-weight: 500;
    font-size: 20px;
    line-height: 200%;
    color: rgba(100, 100, 100, 0.96);
  }

  .spliter {
    height: 0px;
    width: 100%;
    border-top: 1px solid #cacaca;
    margin: 50px auto;
    max-width: 1320px;
    width: calc(100% - 40px);
  }

  .header {
    margin: 0 auto;
    max-width: 1320px;
    width: calc(100% - 40px);
  }

  .active-competition-wrapper {
    margin: 0 auto;
    max-width: 1320px;
    width: calc(100% - 40px);
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    span {
      font-weight: 500;
      font-size: 22px;
      color: #8e3e4c;
      margin-bottom: 20px;
    }

    .competition-info {
      display: flex;
      flex-direction: row;
      align-items: center;
    }
    .point {
      width: 10px;
      height: 10px;
      background: #8e3e4c;
      border-radius: 5px;
      margin-right: 15px;
    }
    .btn-wrapper {
      margin-top: 40px;
      margin-bottom: 50px;
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
    }
    .btn {
      margin-bottom: 20px;
      margin-right: 20px;
    }
  }

  .next-competitions-wrapper {
    background: #f2f2f2;

    .next-competitions {
      margin: 0 auto;
      max-width: 1320px;
      width: calc(100% - 40px);
      display: flex;
      flex-wrap: wrap;
      // flex-direction: column;
      justify-content: space-between;
      align-items: flex-start;
      padding: 60px 0;
    }
  }
  .next-competitions-wrapper.white {
    background: #fff;
  }
  .next-competitions-wrapper.no-wrap {
    .next-competitions {
      flex-wrap: nowrap;
      flex-shrink: 0;
      overflow: auto;
      justify-content: flex-start;
      .wrappNextCompetition {
        margin-right: 24px;
        margin-bottom: 0px;
        width: 500px;
        max-width: 100%;
        flex-shrink: 0;
      }
    }
  }

  .archived-competitions {
    margin: 0 auto;
    max-width: 1320px;
    width: calc(100% - 40px);
    padding-bottom: 80px;

    .archived-competitions-cards-wrapper {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
    }

    a {
      max-width: 100%;
    }

    .competition {
      max-width: 100%;
      width: 420px;
      min-height: 245px;
      background: #8e3e4c;
      padding: 30px;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      margin-right: 20px;
      flex-wrap: wrap;
      margin-bottom: 20px;

      .name {
        font-weight: 500;
        font-size: 24px;
        line-height: 174.9%;
        letter-spacing: 0.03em;
        color: #fcfcfc;
        text-transform: uppercase;
      }
      .theme {
        font-weight: 500;
        font-size: 24px;
        line-height: 194.9%;
        color: #fcfcfc;
        margin-bottom: 10px;
      }
      .date {
        color: white;
      }
    }
  }
}
</style>
<style lang="scss">
.wrappNextCompetition:last-of-type {
  border-right: 2px solid transparent;
}
@media only screen and (max-width: 1000px) {
  .next-competitions-wrapper.no-wrap {
    .next-competitions {
      flex-wrap: nowrap;
      flex-shrink: 0;
      overflow: auto;
      flex-direction: column;
      align-items: center !important;

      .wrappNextCompetition {
        margin-right: 0px !important;
        margin-bottom: 50px !important;
        width: 500px;
        max-width: 100%;
        flex-shrink: 0;
      }
    }
  }
  .wrappNextCompetition:last-of-type {
    border-right: none;
    border-bottom: none;
    padding-bottom: 0;
    margin-bottom: 0px;
  }
}
</style>
